import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    currentSort: 'hot',
    selectedGenres: [],
    selectedTags: [],
};
const worksSlice = createSlice({
    name: 'works',
    initialState,
    reducers: {
        setSort: (state, action) => {
            state.currentSort = action.payload;
        },
        setGenres: (state, action) => {
            state.selectedGenres = action.payload;
        },
        setTags: (state, action) => {
            state.selectedTags = action.payload;
        },
        resetFilters: (state) => {
            state.selectedGenres = [];
            state.selectedTags = [];
        },
    },
});
export const { setSort, setGenres, setTags, resetFilters } = worksSlice.actions;
export default worksSlice.reducer;
// Selectors
export const selectCurrentSort = (state) => state.works.currentSort;
export const selectSelectedGenres = (state) => state.works.selectedGenres;
export const selectSelectedTags = (state) => state.works.selectedTags;
